module.exports = __webpack_public_path__ + "img/slider3.a9f49fa4.svg";